import {RELATIVES_API_URL} from "../../../shared/constants/api";

export const CONTACTS_URL = `${RELATIVES_API_URL}/v2/get_customer_home`;
export const INVITE_URL = `${RELATIVES_API_URL}/v2/invite/add`;
export const DELETE_RELATION_URL = `${RELATIVES_API_URL}/v1/relation/delete`;
export const RELATIVES_URL = `${RELATIVES_API_URL}/get_customers`;
